import React, { memo } from "react";
import { Card } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useLocation, useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";
import { featuresData } from "common/StringUtils";
import { LOCALES } from "common/constants";

const Features = () => {
  const { t } = useTranslation();

  const naviagte = useNavigate();
  const location = useLocation();
  const language = localStorage.getItem("i18nextLng");

  const scrollToElement = async (id) => {
    let elementID;
    switch (id) {
      case 1:
        elementID = "invite_others";
        break;
      case 2:
        elementID = "set_aside";
        break;
      case 3:
        elementID = "request_express";
        break;
      case 4:
        elementID = "invoicing_different_countries";
        break;
      case 5:
        elementID = "salary_change";
        break;
      case 6:
        elementID = "write_agreements";
        break;
      case 7:
        elementID = "insurance";
        break;
      case 8:
        elementID = "time_reports";
        break;
      case 9:
        elementID = "create_credit_invoice";
        break;
      case 10:
        elementID = "change_vat_rate";
        break;
      case 11:
        elementID = "have_salary";
        break;
      case 12:
        elementID = "invoicing";
        break;
         case 13:
        elementID = "faster_salary";
        break;
      default:
        elementID = "";
    }

    const appendBackButton = (container) => {
      if (!container.querySelector(".back-button")) {
        // Check if the button already exists
        const backButton = document.createElement("button");
        backButton.textContent = t("Go Back");
        backButton.className = "back-button";
        backButton.style.padding = "8px 20px";
        backButton.style.fontSize = "16px";
        backButton.style.color = "#fff";
        backButton.style.backgroundColor = "#5d47b6";
        backButton.style.border = "none";
        backButton.style.borderRadius = "5px";
        backButton.style.cursor = "pointer";
        backButton.style.boxShadow = "0 2px 5px rgba(0,0,0,0.2)";
        backButton.onclick = () => {
          window.history.back();
        };
        container.appendChild(backButton);
      }
    };

    const container = document.getElementById(elementID);
    if (container) {
      container.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      appendBackButton(container);
    } else {
      if (language === LOCALES.EN_US) {
        await naviagte(`/function?lang=${LOCALES.EN_US}`);
      } else {
        await naviagte(`/funktion?lang=${LOCALES.SV_SE}`);
      }
      const container = document.getElementById(elementID);
      container.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      appendBackButton(container);
    }
  };

  return (
    <section className="features new_feater_set_design new_fcture_dengs dashboard">
      <div className="container">
        {!location.pathname.includes("dashboard") &&
          !location.pathname.includes("instrumentbrada") && (
            <div className="row no-gutters">
              <div className="col-sm-12">
                <div className="feature-heading">
                  <h2>{t("Features of the invoicing tool")}</h2>
                  <p>
                    {t(
                      "With our invoicing tool, you can, without starting a business, perform the following in our platform:"
                    )}
                  </p>
                </div>
              </div>
            </div>
          )}

        <div className="feature-group">
          <Row className="invoice-features">
            {featuresData?.map((data, idx) => {
              return (
                <Col key={idx} md={6} className="mb-4">
                  <Card
                    border="primary"
                    className="h-100 overflow-hidden shadow"
                  >
                    <Card.Body
                      className="faq_home_card cursor-pointer"
                      onClick={() => scrollToElement(data?.id)}
                    >
                      <div className="content">
                        <div className="imge_icns">
                          <img
                            alt="card_image"
                            src={data?.image}
                            loading="lazy"
                          />
                        </div>
                        <div className="content-group">
                          <h3 className="new_card-design" id={data.id}>
                            {t(data?.title)}
                          </h3>
                          <Card.Text>{t(data?.description)}</Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                    <div className="go">
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 49 49"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="feature"
                      >
                        <path
                          d="M24.4997 44.9193C35.7756 44.9193 44.9163 35.7786 44.9163 24.5026C44.9163 13.2268 35.7756 4.08594 24.4997 4.08594C13.2239 4.08594 4.08301 13.2268 4.08301 24.5026C4.08301 35.7786 13.2239 44.9193 24.4997 44.9193Z"
                          fill="#CFDCDF"
                        ></path>
                        <path
                          d="M24.4997 44.9193C35.7756 44.9193 44.9163 35.7786 44.9163 24.5026C44.9163 13.2268 35.7756 4.08594 24.4997 4.08594C13.2239 4.08594 4.08301 13.2268 4.08301 24.5026C4.08301 35.7786 13.2239 44.9193 24.4997 44.9193Z"
                          stroke="#232323"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M15.0771 24.5039H33.9233"
                          stroke="#232323"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M29.2129 19.7891L33.9244 24.5006L29.2129 29.2121"
                          stroke="#232323"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                    </div>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </div>
      </div>
    </section>
  );
};

export default memo(Features);
